<template>
  <div class="loading-modal">
    <div class="spinner-card">
      <div class="dots">
        <div class="car">🚗</div>
      </div>
      <p class="loading-text">{{ loadingText }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingSpinner",
  props: {
    loadingText: {
      type: String,
      default: "檢驗登入中...",
    },
  },
};
</script>

<style scoped>

.car {
  font-size: 66px;
  display: inline-block;
  animation: drive 1.8s infinite ease-in-out;
}

@keyframes drive {

  /* 🚗 往右（車頭朝右） */
  0% {
    transform: translateX(-30px) scaleX(-1);
  }

  40% {
    transform: translateX(30px) scaleX(-1);
  }

  /* 🔥 轉頭（準備往左） */
  50% {
    transform: translateX(30px) scaleX(1);
  }

  /* 🚗 往左（車頭朝左） */
  90% {
    transform: translateX(-30px) scaleX(1);
  }

  /* 🔥 再轉回來 */
  100% {
    transform: translateX(-30px) scaleX(-1);
  }
}


.loading-modal {
  position: fixed;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1000;
}


.spinner-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;

  margin-top: 250px;
  width: 240px;
  height: 240px;
  background-color: white;
  border-radius: 20px;
  padding: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);


}

.dots {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  margin-top: 50px;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: var(--green05);
  animation: bounce 1.5s infinite;
}

.dot:nth-child(1) {
  animation-delay: 0s;
}

.dot:nth-child(2) {
  animation-delay: 0.3s;
}

.dot:nth-child(3) {
  animation-delay: 0.6s;
}

@keyframes bounce {

  0% {
    background-color: var(--green01);
  }

  33% {
    background-color: var(--green03);
  }

  66% {
    background-color: var(--green05);
  }

  100% {
    background-color: var(--green01);
  }


}

.loading-text {
  /* //styleName: md/bold; */
  font-family: Inter;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  color: var(--green03);

}


@media screen and (max-width: 560px) {
  .spinner-card {
    margin-top: 200px;

    width: 160px;
    height: 160px;
  }

  .dots {
    margin-top: 10px;
    margin-bottom:0px;
  }


  .loading-text {

    /* //styleName: sm/bold; */
    font-family: Inter;
    font-size: 14px;
    font-weight: 700;
    line-height: 21.56px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    margin-top:10px;

  }


}
</style>